import type { Icon } from "@phosphor-icons/react";
import { useActionContext } from "~/actions/context";
import { type Action, isVisible, resolve } from "~/actions/types";

export interface ActionButtonProps {
  title: string;
  icon?: Icon;
  visible: boolean;
  onClick: () => void;
}

/**
 * The third surface: a plain button. Same declaration, same analytics, different source —
 * which is the entire point of declaring capabilities once.
 */
export function useActionButton(action: Action, activeEntityId?: string): ActionButtonProps {
  const context = useActionContext({
    source: "button",
    ...(activeEntityId === undefined ? {} : { activeEntityId }),
  });

  return {
    title: resolve(action.name, context),
    ...(action.icon ? { icon: action.icon } : {}),
    visible: isVisible(action, context) && Boolean(action.perform),
    onClick: () => {
      void action.perform?.(context);
    },
  };
}
